<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__welcome">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--welcome is-hidden-mobile"
      :style="`background-image: url(${imgBuqueNoiva})`"
    ></div>
    <div
      class="column has-text-centered onboarding-create-site__description onboarding-create-site__description--welcome"
    >
      <div class="onboarding-create-site__description--width-80">
        <p class="onboarding-create-site__emotion">🥰</p>
        <h1
          v-if="mySiteInfo.data"
          class="onboarding-create-site__title has-text-weight-bold"
        >
          Sejam bem-vindos {{ mySiteInfo.data.noivo1_nome }} e
          {{ mySiteInfo.data.noivo2_nome }}
        </h1>
        <p class="onboarding-create-site__subtitle">
          Vamos ajudar vocês a criarem o seu site e, por isso, precisamos
          conhecê-los um pouco mais
        </p>
      </div>
      <router-link
        :to="{ path: '/onboarding/passo-1' }"
        class="button is-primary"
        replace
        >Começar</router-link
      >
    </div>
  </div>
</template>

<script>
import imgBuqueNoiva from '@/assets/img/onboarding-create-site/buque-noiva.jpg'

export default {
  data() {
    return {
      imgBuqueNoiva,
      mySiteInfo: {},
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    dataWed() {
      return this.$store.state.onboardingCreateSite.data_wedding
    },
  },

  watch: {
    dataWed() {
      this.mySiteInfo = this.$store.state.onboardingCreateSite.data_wedding
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__img {
    &--welcome {
      margin-top: 12px;
    }
  }

  &__description {
    &--welcome {
      min-height: calc(100vh - 48px) !important;
    }
  }
}
</style>
